<template lang="pug">
.find-roll
  .panel.panel-default
    .panel-body
      form.lookup(@submit.prevent="lookup()")
        .col-sm-5.smallpadding
          label Select Channel
          div
            select.form-control(v-model="selectedChannel")
              option(:value="-1") Default (Global Scope)
              option(v-for="c in channels" :value="c.cfgId") {{c.name}}
        .col-sm-7.smallpadding
          .col-sm-12
            label Select a roll by scanning a code
          .col-sm-8
            input#find-roll-code-input.form-control(placeholder="Code" v-model="code")
          .col-sm-4.smallpadding
            SspActionButton.form-control(type="submit" :disabled="!code" :spinning="looking" text="Search")

  .alert.alert-danger(v-if="lookupErrorMsg") {{lookupErrorMsg}}
  .alert.alert-info(v-if="loading") Loading...

  .panel.panel-default(v-if="rollInfo")
    .panel-body
      h2.pull-left Roll: {{rollInfo.description}}

      .clearfix
      .roll-info(style="padding: 10px 0px")
        .info(v-if="rollInfo.calibrated && rollInfo.unassigned") First available code: {{rollInfo.unassigned.first.code}}
        RollProgressVisualization(:rollInfo="rollInfo")

      .activations
        h3 Activations
        ActivationsTable(
          :code="noUrlCode"
          @row-click="gotoSection"
          @calibrate="calibrate()"
          @nextActivation="nextActivation()"
          :isFullyActivated="rollInfo.calibrated && !rollInfo.unassigned"
          :isCalibrated="rollInfo.calibrated")
</template>
<script>
import Util from '@/service/Util'
import activationSession from '../service/ActivationSession'
import ActivationsTable from '../components/ActivationsTable'
import RollProgressVisualization from '../components/RollProgressVisualization'

export default {
  data: () => ({
    looking: false,
    code: null,
    noUrlCode: null,
    lookupErrorMsg: null,
    rollInfo: null,
    loading: false,
    channels: [],
    activations: null,
    selectedChannel: null
  }),
  created() {
    this.selectedChannel = this.$route.query.channel || -1
    this.code = this.$route.query.code ? Util.removeUrl(this.$route.query.code) : this.noUrlCode
    activationSession.getChannelsWithCodeConfig()
      .then((channels) => {
        this.channels = channels
      })
      .catch((e) => { this.$emit('error', e) })

    if (this.code) {
      this.lookup()
    }
  },
  mounted() {
    const focusElement = this.$el.querySelector('#find-roll-code-input')
    focusElement.focus()
  },
  methods: {
    lookup() {
      this.looking = true
      this.noUrlCode = Util.removeUrl(this.code)
      this.$router.push({
        query: {
          code: this.noUrlCode,
          channel: this.selectedChannel
        }
      })
      this.loading = true
      this.rollInfo = null
      this.lookupErrorMsg = null
      activationSession
        .startSession(this.noUrlCode, this.selectedChannel)
        .then((rollInfo) => {
          this.rollInfo = rollInfo
          this.loading = false
        })
        .catch((e) => {
          if (e.response.status === 400 || e.response.status === 404) {
            this.lookupErrorMsg = e.response.data.message
          } else {
            this.$emit('error', e)
          }
          this.loading = false
        })
        .then(() => {
          this.looking = false
        })
    },
    nextActivation() {
      this.$emit('next')
    },
    calibrate() {
      this.$router.push({ name: 'calibration' })
    },
    gotoSection(section) {
      this.$router.push({ name: 'sectionMetadata', params: { orderId: section.orderId, sectionId: section.id } })
    }
  },
  components: {
    RollProgressVisualization,
    ActivationsTable
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/activator/wiz/FindRoll.vue